export enum DisciplineStudyReviewerRole {
	LegalResearcher = 1,
	DepartmentHead = 2,
	DepartmentManager = 3,
}
